import {Button} from '@components/ui/button'
import {XCloseIcon} from '@components/ui/icon'
import {Spinner} from '@components/ui/spinner'
import {forwardRef, HTMLAttributes, ReactNode} from 'react'
import {cn} from '@utilities/helpers'

interface AreaItemProps extends Omit<HTMLAttributes<HTMLDivElement>, 'id'> {
    label?: string
    children?: ReactNode
    countryCode?: string
    removeSelectedArea?: () => void
    isLoading?: boolean
}

export const AreaItem = forwardRef<HTMLDivElement, AreaItemProps>(
    ({label, countryCode, children, className, removeSelectedArea, isLoading = false, ...props}, ref) => {
        return (
            <div
                ref={ref}
                className={cn(
                    'flex items-center gap-1.5 rounded-2xl border border-neutral-300 bg-white py-1.5 px-3 text-sm font-medium',
                    '[&_svg]:cursor-pointer [&_svg]:fill-neutral-600',
                    '[&_span]:font-normal [&_span]:text-neutral-600',
                    className
                )}
                {...props}
            >
                {children ?? (
                    <>
                        <p>{label}</p>
                        {countryCode && <span>({countryCode})</span>}
                        {removeSelectedArea && (
                            <Button
                                variant="ghost"
                                size="sm"
                                shape="text"
                                onClick={removeSelectedArea}
                                disabled={isLoading}
                            >
                                {isLoading ? <Spinner size={20} /> : <XCloseIcon size={20} />}
                            </Button>
                        )}
                    </>
                )}
            </div>
        )
    }
)
